import {createSelector} from "reselect";

export const getBillingPeriods = createSelector(
    [],
    () => {
        return [
            {
                value: 4,
                isDefault: true,
                display: {
                    title: "1x pro Jahr"
                }
            },
            {
                value: 3,
                isDefault: false,
                display: {
                    title: "2x pro Jahr"
                }
            },
            {
                value: 2,
                isDefault: false,
                display: {
                    title: "4x pro Jahr"
                }
            },
            {
                value: 1,
                isDefault: false,
                display: {
                    title: "12x pro Jahr"
                }
            },

        ]
    }
)



/** WEBPACK FOOTER **
 ** ./src/selectors/BillingPeriod.js
 **/